import { OfficeAddress } from "services/api/offices/types";
import { MarketplaceLocation } from "../types";

/**
 * Adresa poslovnice → polja lokacije oglasa.
 *
 * Poslovnica nema općinu, pa se kod stvarne adrese `municipalityCode` namjerno izostavlja iz
 * patcha — što je korisnik ondje upisao ostaje netaknuto.
 *
 * Bez poslovnice (poništen odabir ili prelazak na ručni unos) prazne se SVA polja, uključujući
 * općinu — inače bi na oglasu ostala adresa poslovnice koja s njim više nema veze.
 */
export const mapOfficeAddressToLocation = (
  address: OfficeAddress | null
): Partial<MarketplaceLocation> => {
  if (!address) {
    return {
      countyCode: "",
      municipalityCode: "",
      settlementCode: "",
      manualAddress: "",
    };
  }

  const lines = [address.line1, address.line2].filter((line) => !!line?.trim());

  return {
    countyCode: address.state ?? "",
    settlementCode: address.city ?? "",
    manualAddress: lines.join(", "),
  };
};
